// extracted by mini-css-extract-plugin
export default {"container":"co9skr","support-text":"HKJW7V","supportText":"HKJW7V"};